import { FinancialInstitution } from '../types/financialInstitution';

// Données mockées pour les institutions financières (basées sur la structure du formulaire)
export const mockFinancialInstitutions: FinancialInstitution[] = [
  {
    id: 'inst-001',
    userId: 'user-fi-001',
    
    // Identification institutionnelle
    denominationSociale: 'Banque Congolaise du Commerce',
    sigle: 'BCC',
    typeInstitution: 'BANQUE',
    sousCategorie: 'deposit_credit_bank',
    dateCreation: '2010-03-15',
    paysOrigine: 'RDC',
    statutJuridique: 'sa',
    
    // Informations réglementaires
    autoritéSupervision: 'bcc',
    numeroAgrement: 'BCC/2010/001',
    dateAgrement: '2010-02-28',
    validiteAgrement: '2030-02-28',
    numeroRCCM: 'CD/RCCM/23/B/001',
    numeroNIF: 'A1234567890',
    
    // Activités autorisées
    activitesAutorisees: ['deposit_collection', 'credit_granting', 'payment_services', 'foreign_exchange'],
    
    // Informations opérationnelles
    siegeSocial: '123 Boulevard du 30 Juin, Kinshasa',
    nombreAgences: 15,
    villesProvincesCouvertes: ['Kinshasa', 'Lubumbashi', 'Bukavu', 'Goma'],
    presenceInternationale: false,
    
    // Capacités financières
    capitalSocialMinimum: '10000000',
    capitalSocialActuel: '25000000',
    fondsPropresMontant: '50000000',
    totalBilan: '200000000',
    chiffreAffairesAnnuel: '15000000',
    devise: 'USD',
    
    // Clientèle et marché
    segmentClientelePrincipal: 'sme',
    nombreClientsActifs: 15000,
    portefeuilleCredit: '80000000',
    depotsCollectes: '150000000',
    
    // Services offerts à Wanzo
    servicesCredit: ['sme_credit', 'startup_credit', 'revolving_credit'],
    servicesInvestissement: ['venture_capital', 'project_financing'],
    servicesGarantie: ['bank_guarantees', 'market_bonds'],
    servicesTransactionnels: ['bank_accounts', 'transfers', 'electronic_payments'],
    servicesConseil: ['financial_management', 'financial_structuring'],
    
    // Partenariat Wanzo
    motivationPrincipale: 'new_clients',
    servicesPrioritaires: ['sme_credit', 'venture_capital'],
    segmentsClienteleCibles: ['sme', 'individuals'],
    volumeAffairesEnvisage: '5000000',
    
    // Conditions commerciales
    grillesTarifaires: 'Taux préférentiels pour les partenaires Wanzo: 8-12% selon le profil',
    conditionsPreferentielles: 'Réduction de 1% sur les taux standards pour les clients Wanzo',
    delaisTraitement: '5',
    criteresEligibilite: 'Chiffre d\'affaires minimum 50k USD, 2 ans d\'activité',
    
    // Capacité d'engagement
    montantMaximumDossier: '500000',
    enveloppeGlobale: '10000000',
    secteursActivitePrivilegies: ['commerce', 'services', 'industrie'],
    zonesGeographiquesPrioritaires: ['Kinshasa', 'Lubumbashi'],
    
    // Documents
    documentsLegaux: [],
    documentsFinanciers: [],
    documentsOperationnels: [],
    documentsCompliance: [],

    // Champs de compatibilité
    createdAt: '2010-03-15T00:00:00Z',
    updatedAt: '2024-11-09T10:30:00Z'
  },

  {
    id: 'inst-002',
    userId: 'user-fi-002',
    
    // Identification institutionnelle
    denominationSociale: 'Microfinance du Kasaï',
    sigle: 'MFK',
    typeInstitution: 'MICROFINANCE',
    sousCategorie: 'microfinance_company',
    dateCreation: '2015-08-10',
    paysOrigine: 'RDC',
    statutJuridique: 'sarl',
    
    // Informations réglementaires
    autoritéSupervision: 'bcc',
    numeroAgrement: 'MF/2015/045',
    dateAgrement: '2015-07-20',
    validiteAgrement: '2025-07-20',
    numeroRCCM: 'CD/RCCM/15/B/045',
    numeroNIF: 'M9876543210',
    
    // Activités autorisées
    activitesAutorisees: ['savings', 'microcredit', 'money_transfers', 'financial_education'],
    
    // Informations opérationnelles
    siegeSocial: '456 Avenue Lumumba, Kananga',
    nombreAgences: 8,
    villesProvincesCouvertes: ['Kananga', 'Mbuji-Mayi', 'Tshikapa'],
    presenceInternationale: false,
    
    // Capacités financières
    capitalSocialMinimum: '1000000',
    capitalSocialActuel: '2500000',
    fondsPropresMontant: '5000000',
    totalBilan: '20000000',
    chiffreAffairesAnnuel: '1500000',
    devise: 'USD',
    
    // Clientèle et marché
    segmentClientelePrincipal: 'individuals',
    nombreClientsActifs: 5000,
    portefeuilleCredit: '8000000',
    depotsCollectes: '15000000',
    
    // Services offerts à Wanzo
    servicesCredit: ['sme_credit', 'revolving_credit'],
    servicesInvestissement: [],
    servicesGarantie: ['guarantee_funds'],
    servicesTransactionnels: ['transfers', 'electronic_payments'],
    servicesConseil: ['financial_education'],
    
    // Partenariat Wanzo
    motivationPrincipale: 'portfolio_diversification',
    servicesPrioritaires: ['sme_credit'],
    segmentsClienteleCibles: ['individuals', 'sme'],
    volumeAffairesEnvisage: '1000000',
    
    // Conditions commerciales
    grillesTarifaires: 'Taux microfinance: 15-25% selon le profil et la garantie',
    conditionsPreferentielles: 'Tarifs dégressifs selon le volume pour partenaires Wanzo',
    delaisTraitement: '3',
    criteresEligibilite: 'Activité génératrice de revenus, caution solidaire',
    
    // Capacité d'engagement
    montantMaximumDossier: '50000',
    enveloppeGlobale: '2000000',
    secteursActivitePrivilegies: ['agriculture', 'commerce', 'artisanat'],
    zonesGeographiquesPrioritaires: ['Kasaï-Central', 'Kasaï-Oriental'],
    
    // Documents
    documentsLegaux: [],
    documentsFinanciers: [],
    documentsOperationnels: [],
    documentsCompliance: [],

    // Champs de compatibilité
    createdAt: '2015-08-10T00:00:00Z',
    updatedAt: '2024-11-09T10:30:00Z'
  },

  {
    id: 'inst-003',
    userId: 'user-fi-003',
    
    // Identification institutionnelle
    denominationSociale: 'COOPEC Solidarité',
    sigle: 'COOSOL',
    typeInstitution: 'COOPEC',
    sousCategorie: 'savings_credit_coop',
    dateCreation: '2018-05-22',
    paysOrigine: 'RDC',
    statutJuridique: 'cooperative',
    
    // Informations réglementaires
    autoritéSupervision: 'bcc',
    numeroAgrement: 'COOPEC/2018/012',
    dateAgrement: '2018-04-15',
    validiteAgrement: '2028-04-15',
    numeroRCCM: 'CD/RCCM/18/C/012',
    numeroNIF: 'C5678901234',
    
    // Activités autorisées
    activitesAutorisees: ['savings', 'microcredit', 'money_transfers'],
    
    // Informations opérationnelles
    siegeSocial: '789 Rue de la Paix, Bukavu',
    nombreAgences: 5,
    villesProvincesCouvertes: ['Bukavu', 'Uvira', 'Kamanyola'],
    presenceInternationale: false,
    
    // Capacités financières
    capitalSocialMinimum: '500000',
    capitalSocialActuel: '800000',
    fondsPropresMontant: '1500000',
    totalBilan: '5000000',
    chiffreAffairesAnnuel: '400000',
    devise: 'USD',
    
    // Clientèle et marché
    segmentClientelePrincipal: 'individuals',
    nombreClientsActifs: 1200,
    portefeuilleCredit: '2000000',
    depotsCollectes: '4000000',
    
    // Services offerts à Wanzo
    servicesCredit: ['sme_credit'],
    servicesInvestissement: [],
    servicesGarantie: [],
    servicesTransactionnels: ['transfers'],
    servicesConseil: ['financial_education'],
    
    // Partenariat Wanzo
    motivationPrincipale: 'ecosystem_reputation',
    servicesPrioritaires: ['sme_credit'],
    segmentsClienteleCibles: ['individuals'],
    volumeAffairesEnvisage: '300000',
    
    // Conditions commerciales
    grillesTarifaires: 'Taux coopératifs: 12-18% pour les membres',
    conditionsPreferentielles: 'Taux préférentiels pour membres actifs de longue durée',
    delaisTraitement: '7',
    criteresEligibilite: 'Membre de la coopérative, épargne régulière',
    
    // Capacité d'engagement
    montantMaximumDossier: '25000',
    enveloppeGlobale: '500000',
    secteursActivitePrivilegies: ['agriculture', 'commerce'],
    zonesGeographiquesPrioritaires: ['Sud-Kivu'],
    
    // Documents
    documentsLegaux: [],
    documentsFinanciers: [],
    documentsOperationnels: [],
    documentsCompliance: [],

    // Champs de compatibilité
    createdAt: '2018-05-22T00:00:00Z',
    updatedAt: '2024-11-09T10:30:00Z'
  }
];

// Fonction pour récupérer une institution financière par ID
export const getFinancialInstitutionById = (id: string): FinancialInstitution | undefined => {
  return mockFinancialInstitutions.find(institution => institution.id === id);
};

// Fonction pour récupérer toutes les institutions financières
export const getAllFinancialInstitutions = (): FinancialInstitution[] => {
  return mockFinancialInstitutions;
};

// Fonction pour créer une nouvelle institution financière
export const createMockFinancialInstitution = (institutionData: Omit<FinancialInstitution, 'id' | 'createdAt' | 'updatedAt'>): FinancialInstitution => {
  const newInstitution: FinancialInstitution = {
    ...institutionData,
    id: `inst-${Date.now()}`,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  };
  
  mockFinancialInstitutions.push(newInstitution);
  return newInstitution;
};

// Fonction pour mettre à jour une institution financière
export const updateMockFinancialInstitution = (id: string, updates: Partial<FinancialInstitution>): FinancialInstitution | null => {
  const index = mockFinancialInstitutions.findIndex(institution => institution.id === id);
  if (index === -1) return null;
  
  mockFinancialInstitutions[index] = {
    ...mockFinancialInstitutions[index],
    ...updates,
    updatedAt: new Date().toISOString()
  };
  
  return mockFinancialInstitutions[index];
};